var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Encuesta"},[_c('br'),_c('v-alert',{attrs:{"border":"left","colored-border":"","color":"warning","elevation":"2"}},[_c('p',[_vm._v("Querido estudiante.")]),_c('p',[_vm._v("Le solicitamos completar la encuesta antes de continuar.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }